var _excluded = ["noteType", "InvoiceNumber"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import DateRangeShortcutHelper from 'invision-core/src/components/helpers/daterange.shortcut.helper';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { DateTimeHelper } from 'invision-core';
import { stateGo } from 'redux-ui-router';
import LocaleKeys from '../../../../../locales/keys';
import { BILL_ADJUSTMENT, BILLING_INVOICE_DETAILS_URL, BILLING_PAYMENTS_SEARCH_PLACEHOLDER, CONVERT_TO_CREDIT, CREDIT_NOTE_TYPE, OPEN_INVOICES, OPEN_INVOICES_COL_DEFS, VIEW_RECEIVABLES } from '../../../billing.payments.constants';
import { IsFetchingOpenInvoicesSelector, OpenInvoicesCurrentPageSelector, OpenInvoicesEndDateSelector, OpenInvoicesListSelector, OpenInvoicesPageCountSelector, OpenInvoicesPageSizeSelector, OpenInvoicesRecordCountSelector, OpenInvoicesSearchTermSelector, OpenInvoicesStartDateSelector } from '../../../../../reducers/selectors/customer.billing.selectors';
import { createConvergentBillerAdjustment, retrieveLedgerSummary, updateInvoiceNumberSearchTerm, updateOpenInvoicesDateRange, updateOpenInvoicesPageNumber, updateOpenInvoicesPageSize } from '../../../../../reducers/actions/customer.billing.actions';
import { CurrentCustomerIdSelector } from '../../../../../reducers/selectors/customer.selectors';
import { MISC_ADJUSTMENT } from '../../../../adjustment/adjustment.modal.constants';
import { PAYMENT_ADJUSTMENT_ACCESS } from '../../../../../security.attributes';
import clone from 'ramda/src/clone';
import { CurrentBusinessUnitTimeZoneSelector } from 'invision-core/src/components/session/businessunit.selectors';
var OpenInvoicesController = /*#__PURE__*/function () {
  function OpenInvoicesController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, OpenInvoicesController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CoreLocaleKeys: CoreLocaleKeys,
      LocaleKeys: LocaleKeys,
      OPEN_INVOICES_COL_DEFS: OPEN_INVOICES_COL_DEFS,
      uiNotificationService: uiNotificationService,
      balanceToolTipTemplate: require('../../../../shared/tooltipTemplates/open.invoices.balance.tooltip.template.html'),
      goToInvoiceDetails: this.goToInvoiceDetails.bind(this),
      handleConvertToCreditModalClose: this.handleConvertToCreditModalClose.bind(this),
      onConvertToCreditFormSubmit: this.onConvertToCreditFormSubmit.bind(this),
      invoiceTypeLabel: i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.INVOICE_TYPE),
      isConvertToCreditModalOpen: false,
      isReceivablesModalOpen: false,
      newBalanceLabel: i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.ACCOUNT_BALANCE),
      onOpenInvoiceDateRangeChanged: this.onOpenInvoiceDateRangeChanged.bind(this),
      onReceivablesModalClose: this.onReceivablesModalClose.bind(this),
      onSearchCleared: this.onSearchCleared.bind(this),
      openDialog: this.openDialog.bind(this),
      pageSizeSelected: this.pageSizeSelected.bind(this),
      priorBalanceLabel: i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.PRIOR_BALANCE),
      receivables: [],
      searchInvoiceNumber: this.searchInvoiceNumber.bind(this),
      searchPlaceholder: BILLING_PAYMENTS_SEARCH_PLACEHOLDER(),
      totalOnDemandInvoicesLabel: i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.TOTAL_ON_DEMAND_INVOICES),
      updateOpenInvoicesPageNumber: this.updateOpenInvoicesPageNumber.bind(this)
    });
  }
  return _createClass(OpenInvoicesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentBUTimeZone: CurrentBusinessUnitTimeZoneSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          isFetchingOpenInvoices: IsFetchingOpenInvoicesSelector(store),
          openInvoicesStartDate: OpenInvoicesStartDateSelector(store),
          openInvoicesCurrentPage: OpenInvoicesCurrentPageSelector(store),
          openInvoicesEndDate: OpenInvoicesEndDateSelector(store),
          openInvoicesList: clone(OpenInvoicesListSelector(store)),
          openInvoicesPageCount: OpenInvoicesPageCountSelector(store),
          openInvoicesPageSize: OpenInvoicesPageSizeSelector(store),
          openInvoicesRecordCount: OpenInvoicesRecordCountSelector(store),
          openInvoicesSearchTerm: OpenInvoicesSearchTermSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        createConvergentBillerAdjustment: createConvergentBillerAdjustment,
        retrieveLedgerSummary: retrieveLedgerSummary,
        stateGo: stateGo,
        updateInvoiceNumberSearchTerm: updateInvoiceNumberSearchTerm,
        updateOpenInvoicesDateRange: updateOpenInvoicesDateRange,
        updateOpenInvoicesPageNumber: updateOpenInvoicesPageNumber,
        updateOpenInvoicesPageSize: updateOpenInvoicesPageSize
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.initDateRange();
      this.fetchOpenInvoicesLedger();
      if (hasAccess(this.state.userSecurityAttributes, PAYMENT_ADJUSTMENT_ACCESS)) {
        var isMoreOptionsPresent = OPEN_INVOICES_COL_DEFS.some(function (item) {
          return item.field === 'moreOptions';
        });
        if (!isMoreOptionsPresent) {
          OPEN_INVOICES_COL_DEFS.push({
            field: 'moreOptions',
            displayName: '',
            cellTemplate: require('../cellTemplates/openInvoice.apply.moreOptionsMenu.template.html'),
            width: '*',
            maxWidth: 70,
            enableColumnMoving: false
          });
        }
      }
      this.adjustmentModalConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.adjustmentModalApi = api;
        }
      };
    }
  }, {
    key: "onAdjustmentClose",
    value: function onAdjustmentClose() {
      this.adjustmentModalApi.close();
      this.showAdjustmentModal = false;
      this.fetchOpenInvoicesLedger();
    }
  }, {
    key: "fetchOpenInvoicesLedger",
    value: function fetchOpenInvoicesLedger() {
      var _this2 = this;
      var request = {
        request: {
          Filter: OPEN_INVOICES,
          InvoiceNumber: this.state.openInvoicesSearchTerm || undefined,
          StartDate: this.state.openInvoicesStartDate || undefined,
          EndDate: this.state.openInvoicesEndDate || undefined,
          PageSize: this.state.openInvoicesPageSize,
          PageNumber: this.state.openInvoicesCurrentPage
        },
        customerId: this.state.currentCustomerId
      };
      this.actions.retrieveLedgerSummary(request, true).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "handleMoreOptionsMenuSelected",
    value: function handleMoreOptionsMenuSelected(rowEntity, item) {
      switch (item.item.id) {
        case CONVERT_TO_CREDIT:
          this.convertToCreditInitialValues = {
            AccountNumber: rowEntity.accountNumber,
            noteType: CREDIT_NOTE_TYPE,
            InvoiceId: rowEntity.invoiceId,
            InvoiceNumber: rowEntity.invoiceNumber,
            Amount: Math.abs(rowEntity.currentDue),
            GenerateStatement: true
          };
          this.isConvertToCreditModalOpen = true;
          break;
        case BILL_ADJUSTMENT:
          this.openDialog(rowEntity.accountNumber, rowEntity.invoiceId, rowEntity.invoiceNumber);
          break;
        case VIEW_RECEIVABLES:
          this.openReceivablesModal(rowEntity.receivables, rowEntity.currencyCode);
          break;
        default:
          break;
      }
    }
  }, {
    key: "onConvertToCreditFormSubmit",
    value: function onConvertToCreditFormSubmit(formValues) {
      var _this3 = this;
      var noteType = formValues.noteType,
        InvoiceNumber = formValues.InvoiceNumber,
        convertToCreditFormValues = _objectWithoutProperties(formValues, _excluded);
      var currentDateInBillingTimezone = DateTimeHelper.offsetTimezone(new Date(), this.state.currentBUTimeZone);
      var request = {
        customerId: this.state.currentCustomerId,
        request: _objectSpread({
          AdjustmentTypeCode: CONVERT_TO_CREDIT,
          PostDate: currentDateInBillingTimezone
        }, convertToCreditFormValues)
      };
      this.actions.createConvergentBillerAdjustment(request).then(function () {
        _this3.isConvertToCreditModalOpen = false;
        _this3.fetchOpenInvoicesLedger();
        _this3.uiNotificationService.transientSuccess(i18n.translate(_this3.LocaleKeys.CONVERT_TO_CREDIT_SUCCESS));
      }).catch(function (error) {
        _this3.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "handleConvertToCreditModalClose",
    value: function handleConvertToCreditModalClose() {
      this.isConvertToCreditModalOpen = false;
    }
  }, {
    key: "openDialog",
    value: function openDialog(accountNumber, invoiceId, invoiceNumber) {
      var _this4 = this;
      this.adjustmentType = MISC_ADJUSTMENT;
      this.adjustmentModal = {
        accountNumber: accountNumber,
        invoiceId: invoiceId,
        invoiceNumber: invoiceNumber
      };
      this.showAdjustmentModal = true;
      this.$timeout(function () {
        _this4.adjustmentModalApi.open();
      });
    }
  }, {
    key: "searchInvoiceNumber",
    value: function searchInvoiceNumber(invoiceNumber) {
      if (invoiceNumber) {
        this.actions.updateInvoiceNumberSearchTerm(invoiceNumber.trim());
        this.fetchOpenInvoicesLedger();
      }
    }
  }, {
    key: "initDateRange",
    value: function initDateRange() {
      var entireHistoryDateShortcut = DateRangeShortcutHelper.getNullableOption(i18n.translate(this.LocaleKeys.ALL_TIME));
      this.shortcuts = [[entireHistoryDateShortcut].concat(_toConsumableArray(DateRangeShortcutHelper.getShortListShortcuts())), _toConsumableArray(DateRangeShortcutHelper.getRelativeShortListShortcuts())];
      this.selectedShortcut = !(this.state.openInvoicesStartDate && this.state.openInvoicesEndDate) ? entireHistoryDateShortcut : null;
    }
  }, {
    key: "updateOpenInvoicesPageNumber",
    value: function updateOpenInvoicesPageNumber(pageNumber) {
      this.actions.updateOpenInvoicesPageNumber(pageNumber);
      this.fetchOpenInvoicesLedger();
    }
  }, {
    key: "onOpenInvoiceDateRangeChanged",
    value: function onOpenInvoiceDateRangeChanged(startDate, endDate, selectedShortcut) {
      this.actions.updateOpenInvoicesDateRange(startDate, endDate, selectedShortcut && selectedShortcut.urlId ? selectedShortcut.urlId : null);
      this.fetchOpenInvoicesLedger();
    }
  }, {
    key: "onSearchCleared",
    value: function onSearchCleared() {
      this.actions.updateInvoiceNumberSearchTerm(null);
      this.fetchOpenInvoicesLedger();
    }
  }, {
    key: "goToInvoiceDetails",
    value: function goToInvoiceDetails(invoiceId) {
      this.actions.stateGo(BILLING_INVOICE_DETAILS_URL, {
        invoiceId: invoiceId
      });
    }
  }, {
    key: "pageSizeSelected",
    value: function pageSizeSelected(pageSize) {
      this.actions.updateOpenInvoicesPageSize(pageSize);
      this.fetchOpenInvoicesLedger();
    }
  }, {
    key: "openReceivablesModal",
    value: function openReceivablesModal(receivables, currency) {
      this.receivables = receivables;
      this.invoiceCurrency = currency;
      this.isReceivablesModalOpen = true;
    }
  }, {
    key: "onReceivablesModalClose",
    value: function onReceivablesModalClose() {
      this.isReceivablesModalOpen = false;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  controller: OpenInvoicesController,
  controllerAs: 'OpenInvoicesController',
  template: require('./open.invoices.template.html')
};